import { useQuery, UseQueryResult } from 'react-query'
import { getAllCategorizedTreatments } from 'src/services/api/treatment'
import { CategorizedAndUniqueTreatments } from '@customTypes/CategorizedTreatment'
import { useConfig } from '@context/ConfigurationContext'
import { fiveMinutesInMiliseconds } from 'src/config/constants'
import { Variants } from 'src/lib'

export const useCityTreatments: (city?: string) => UseQueryResult<CategorizedAndUniqueTreatments> = (city?: string) => {
  const { variant } = useConfig()
  let variantCityName: string | undefined = undefined

  if (variant?.type === Variants.City) {
    const { cityName } = variant || {}
    variantCityName = cityName
  }

  const cityName = city || variantCityName

  const result = useQuery(
    ['categorizedTreatmentsInCityPublic', cityName],
    () => getAllCategorizedTreatments(cityName!),
    {
      retry: 3,
      enabled: !!cityName,
      staleTime: fiveMinutesInMiliseconds,
    }
  )

  return result
}
